import { FormGroup, FormParagraph, Select } from '@ksyos/design-system';
import type { IOrganizationGeneralSettings } from '@common/validation/organization';
import { OrganizationType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';

type OrganizationTypeFormGroupProps = {
    canEdit: boolean;
    onChange: <Key extends keyof IOrganizationGeneralSettings>(
        key: Key,
        value: IOrganizationGeneralSettings[Key]
    ) => void;
    organizationType: OrganizationType;
};

export function OrganizationTypeFormGroup({
    canEdit,
    organizationType,
    onChange,
}: Readonly<OrganizationTypeFormGroupProps>) {
    const translate = getSelectedLanguage();

    return (
        <FormGroup
            isRequired={canEdit}
            label={translate.organization.organizationType}
        >
            {!canEdit && <FormParagraph>{translate.organizationTypeEnum[organizationType]}</FormParagraph>}
            {canEdit && (
                <Select
                    onChange={(item) => {
                        if (item?.value) {
                            onChange('organizationType', item.value);
                        }
                    }}
                    options={Object.values(OrganizationType).map((enumValue) => ({
                        label: translate.organizationTypeEnum[enumValue],
                        value: enumValue,
                    }))}
                    required={true}
                    value={
                        organizationType
                            ? {
                                  label: translate.organizationTypeEnum[organizationType],
                                  value: organizationType,
                              }
                            : null
                    }
                />
            )}
        </FormGroup>
    );
}
